export enum SlugsEnum {
  AdminPanel = 'tsi:webapp:Administration:execute_sidebar_icon',
  CollaboratorsWriteLessThan21 = 'tsi:webapp:sharing:write_collaborators:<21',
  CalibrationWrite = 'tsi:webapp:user_calibration:write',
  DashboardCreateWidget = 'tsi:webapp:dashboard:create_widget',
  DeveloperPanel = 'tsi:webapp:Developer:execute_sidebar_icon',
  GasExportMonth = 'tsi:webapp:history-chart:execute_export:month',
  HistoryChartExecuteExportDay = 'tsi:webapp:history-chart:execute_export:=day',
  LoggingIntervalWriteGreaterThan1 = 'tsi:webapp:device_settings:write_logging_interval:>1',
  MapViewPin = 'tsi:webapp:map:view_pin', // Also used for what previously was tsi:webapp:Devices:execute_menu_choice:View_on_Map
  MenuAlertSetup = 'tsi:webapp:Devices:execute_menu_choice:Alert_Set_Up',
  MenuCurrentReadings = 'tsi:webapp:Devices:execute_menu_choice:Current_Readings',
  MenuHistory = 'tsi:webapp:Devices:execute_menu_choice:History',
  MenuSharing = 'tsi:webapp:Devices:execute_menu_choice:Sharing',
  SideBarDashboardExecute = 'tsi:webapp:dashboard:execute_sidebar_icon',
  SideBarDataServicesExecute = 'tsi:Data_Services:API:execute_sidebar_icon',
  SideBarStudyManagerExecute = 'tsi:webapp:study_manager:execute_sidebar_icon',
  LogInAs = 'tsi:webapp:Administration:execute_menu_choice:Log_In_As'
}
